export const superAdminUsers = [
  'stellar@universal.edu.in',
  'hardik+hats@joinether.in',
  'tharuneswar.d+admin@joinether.in',
  'pravin.shukla+admin@joinether.in',
  'mohammed.hussain+admin@joinether.in',
  'karthik.nr+admin@joinether.in',
  'obaid+admin@joinether.in',
  'gaurav.rai+uahm@universal.edu.in',
  'gaurav.rai+uht@universal.edu.in',
  'varsha.jayashankar+uahm@universal.edu.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'sankar+uahm@joinether.in',
  'amir.shaikh+ab@universal.edu.in',
  'amir.shaikh+acis@universal.edu.in',
  'amir.shaikh+apm@universal.edu.in',
  'amir.shaikh+awv@universal.edu.in',
  'amir.shaikh+eisb@universal.edu.in',
  'amir.shaikh+eisn@universal.edu.in',
  'amir.shaikh+ppsb@universal.edu.in',
  'amir.shaikh+sju@universal.edu.in',
  'amir.shaikh+sous@universal.edu.in',
  'amir.shaikh+uahm@universal.edu.in',
  'amir.shaikh+uhd@universal.edu.in',
  'amir.shaikh+uhm@universal.edu.in',
  'amir.shaikh+uhsa@universal.edu.in',
  'amir.shaikh+uhsc@universal.edu.in',
  'amir.shaikh+uht@universal.edu.in',
  'amir.shaikh+usg@universal.edu.in',
  'amir.shaikh+ust@universal.edu.in',
  'amir.shaikh+ihs@universal.edu.in',
  'amir.shaikh+sws-andheri@universal.edu.in',
  'amir.shaikh+sws-bandra@universal.edu.in',
  'amir.shaikh+sws-goregaon@universal.edu.in',
  'barkha.dhepe+ab@universal.edu.in',
  'barkha.dhepe+acis@universal.edu.in',
  'barkha.dhepe+apm@universal.edu.in',
  'barkha.dhepe+awv@universal.edu.in',
  'barkha.dhepe+eisb@universal.edu.in',
  'barkha.dhepe+eisn@universal.edu.in',
  'barkha.dhepe+ppsb@universal.edu.in',
  'barkha.dhepe+sju@universal.edu.in',
  'barkha.dhepe+sous@universal.edu.in',
  'barkha.dhepe+ihs@universal.edu.in',
  'barkha.dhepe+sws-andheri@universal.edu.in',
  'barkha.dhepe+sws-bandra@universal.edu.in',
  'barkha.dhepe+sws-goregaon@universal.edu.in',
  'barkha.dhepe+uahm@universal.edu.in',
  'barkha.dhepe+uhd@universal.edu.in',
  'barkha.dhepe+uhm@universal.edu.in',
  'barkha.dhepe+uhsa@universal.edu.in',
  'barkha.dhepe+uhsc@universal.edu.in',
  'barkha.dhepe+uht@universal.edu.in',
  'barkha.dhepe+usg@universal.edu.in',
  'barkha.dhepe+ust@universal.edu.in',
  'gaurav+ab@joinether.in',
  'gaurav+acis@joinether.in',
  'gaurav+apm@joinether.in',
  'gaurav+awv@joinether.in',
  'gaurav+eisb@joinether.in',
  'gaurav+eisn@joinether.in',
  'gaurav+ihs@joinether.in',
  'gaurav+local@joinether.in',
  'gaurav+ppsb@joinether.in',
  'gaurav+sju@joinether.in',
  'gaurav+sous@joinether.in',
  'gaurav+sws-a@joinether.in',
  'gaurav+sws-b@joinether.in',
  'gaurav+sws-g@joinether.in',
  'gaurav+uahm@joinether.in',
  'gaurav+uhd@joinether.in',
  'gaurav+uhm@joinether.in',
  'gaurav+uhsa@joinether.in',
  'gaurav+uhsc@joinether.in',
  'gaurav+uht@joinether.in',
  'gaurav+usg@joinether.in',
  'gaurav+ust@joinether.in',
  'sankar+ab@joinether.in',
  'sankar+acis@joinether.in',
  'sankar+apm@joinether.in',
  'sankar+awv@joinether.in',
  'sankar+eisb@joinether.in',
  'sankar+eisn@joinether.in',
  'sankar+ihs@joinether.in',
  'sankar+local@joinether.in',
  'sankar+ppsb@joinether.in',
  'sankar+sju@joinether.in',
  'sankar+sous@joinether.in',
  'sankar+sws-a@joinether.in',
  'sankar+sws-b@joinether.in',
  'sankar+sws-g@joinether.in',
  'sankar+uahm@joinether.in',
  'sankar+uhd@joinether.in',
  'sankar+uhm@joinether.in',
  'sankar+uhsa@joinether.in',
  'sankar+uhsc@joinether.in',
  'sankar+uht@joinether.in',
  'sankar+usg@joinether.in',
  'sankar+ust@joinether.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'jay.sharma+admin@joinether.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'manjusha.bpis@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com',
  'admin@bpismumbai.com'
];

export const usersWithRolloverDashboardAccess = [
  'hardik+hats@joinether.in',
  'stellar@universal.edu.in',
  'dgm.admin@universal.edu.in',
  'gm.co@universal.edu.in',
  'coo@universal.edu.in',
  'shreyas@technogise.com',
  'pinky@universal.edu.in',
  'stellar@universal.edu.in',
  'nauka+localschooladmin@joinether.in',
  'head.accounts@universal.edu.in',
  'suresh.iyer+sous@universal.edu.in',
  'erp.support+uhd@universal.edu.in',
  'head.admissions@universal.edu.in',
  'gaurav.rai+uahm@universal.edu.in',
  'gaurav.rai+uht@universal.edu.in',
  'varsha.jayashankar+uahm@universal.edu.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'sankar+uahm@joinether.in',
  'mahesh.khairnar+admin@universal.edu.in',
  'gaurav+ab@joinether.in',
  'gaurav+acis@joinether.in',
  'gaurav+apm@joinether.in',
  'gaurav+awv@joinether.in',
  'gaurav+eisb@joinether.in',
  'gaurav+eisn@joinether.in',
  'gaurav+ihs@joinether.in',
  'gaurav+local@joinether.in',
  'gaurav+ppsb@joinether.in',
  'gaurav+sju@joinether.in',
  'gaurav+sous@joinether.in',
  'gaurav+sws-a@joinether.in',
  'gaurav+sws-b@joinether.in',
  'gaurav+sws-g@joinether.in',
  'gaurav+uahm@joinether.in',
  'gaurav+uhd@joinether.in',
  'gaurav+uhm@joinether.in',
  'gaurav+uhsa@joinether.in',
  'gaurav+uhsc@joinether.in',
  'gaurav+uht@joinether.in',
  'gaurav+usg@joinether.in',
  'gaurav+ust@joinether.in',
  'sankar+ab@joinether.in',
  'sankar+acis@joinether.in',
  'sankar+apm@joinether.in',
  'sankar+awv@joinether.in',
  'sankar+eisb@joinether.in',
  'sankar+eisn@joinether.in',
  'sankar+ihs@joinether.in',
  'sankar+local@joinether.in',
  'sankar+ppsb@joinether.in',
  'sankar+sju@joinether.in',
  'sankar+sous@joinether.in',
  'sankar+sws-a@joinether.in',
  'sankar+sws-b@joinether.in',
  'sankar+sws-g@joinether.in',
  'sankar+uahm@joinether.in',
  'sankar+uhd@joinether.in',
  'sankar+uhm@joinether.in',
  'sankar+uhsa@joinether.in',
  'sankar+uhsc@joinether.in',
  'sankar+uht@joinether.in',
  'sankar+usg@joinether.in',
  'sankar+ust@joinether.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'jay.sharma+admin@joinether.in',
  'cfo@universal.edu.in',
  'coo.co@universal.edu.in',
  'chetana.govekar+ab@universal.edu.in',
  'chetana.govekar+acis@universal.edu.in',
  'chetana.govekar+apm@universal.edu.in',
  'chetana.govekar+awv@universal.edu.in',
  'chetana.govekar+eisb@universal.edu.in',
  'chetana.govekar+eisn@universal.edu.in',
  'chetana.govekar+ihs@universal.edu.in',
  'chetana.govekar+ppsb@universal.edu.in',
  'chetana.govekar+sju@universal.edu.in',
  'chetana.govekar+sous@universal.edu.in',
  'chetana.govekar+sws-andheri@universal.edu.in',
  'chetana.govekar+sws-bandra@universal.edu.in',
  'chetana.govekar+sws-goregaon@universal.edu.in',
  'chetana.govekar+uahm@universal.edu.in',
  'chetana.govekar+uhd@universal.edu.in',
  'chetana.govekar+uhm@universal.edu.in',
  'chetana.govekar+uhsa@universal.edu.in',
  'chetana.govekar+uhsc@universal.edu.in',
  'chetana.govekar+uht@universal.edu.in',
  'chetana.govekar+usg@universal.edu.in',
  'chetana.govekar+ust@universal.edu.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com',
  'ayushi.bpis@gmail.com'
];

export const usersWithConcessionApprovalAccess = [
  'stellar@universal.edu.in',
  'gaurav.rai+uahm@universal.edu.in',
  'hardik+hats@joinether.in',
  'tharuneswar.d+admin@joinether.in',
  'pravin.shukla+admin@joinether.in',
  'mohammed.hussain+admin@joinether.in',
  'karthik.nr+admin@joinether.in',
  'obaid+admin@joinether.in',
  'gaurav.rai+uht@universal.edu.in',
  'varsha.jayashankar+uahm@universal.edu.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'sankar+uahm@joinether.in',
  'amir.shaikh+ab@universal.edu.in',
  'amir.shaikh+acis@universal.edu.in',
  'amir.shaikh+apm@universal.edu.in',
  'amir.shaikh+awv@universal.edu.in',
  'amir.shaikh+eisb@universal.edu.in',
  'amir.shaikh+eisn@universal.edu.in',
  'amir.shaikh+ppsb@universal.edu.in',
  'amir.shaikh+sju@universal.edu.in',
  'amir.shaikh+sous@universal.edu.in',
  'amir.shaikh+uahm@universal.edu.in',
  'amir.shaikh+uhd@universal.edu.in',
  'amir.shaikh+uhm@universal.edu.in',
  'amir.shaikh+uhsa@universal.edu.in',
  'amir.shaikh+uhsc@universal.edu.in',
  'amir.shaikh+uht@universal.edu.in',
  'amir.shaikh+usg@universal.edu.in',
  'amir.shaikh+ust@universal.edu.in',
  'amir.shaikh+sws-andheri@universal.edu.in',
  'amir.shaikh+sws-bandra@universal.edu.in',
  'amir.shaikh+sws-goregaon@universal.edu.in',
  'barkha.dhepe+ab@universal.edu.in',
  'barkha.dhepe+acis@universal.edu.in',
  'barkha.dhepe+apm@universal.edu.in',
  'barkha.dhepe+awv@universal.edu.in',
  'barkha.dhepe+eisb@universal.edu.in',
  'barkha.dhepe+eisn@universal.edu.in',
  'barkha.dhepe+ppsb@universal.edu.in',
  'barkha.dhepe+sju@universal.edu.in',
  'barkha.dhepe+sous@universal.edu.in',
  'barkha.dhepe+sws-andheri@universal.edu.in',
  'barkha.dhepe+sws-bandra@universal.edu.in',
  'barkha.dhepe+sws-goregaon@universal.edu.in',
  'barkha.dhepe+uahm@universal.edu.in',
  'barkha.dhepe+uhd@universal.edu.in',
  'barkha.dhepe+uhm@universal.edu.in',
  'barkha.dhepe+uhsa@universal.edu.in',
  'barkha.dhepe+uhsc@universal.edu.in',
  'barkha.dhepe+uht@universal.edu.in',
  'barkha.dhepe+usg@universal.edu.in',
  'barkha.dhepe+ust@universal.edu.in',
  'admission.primus@primusschool.edu.in',
  'admissions+ab@alphaeducation.edu.in',
  'admissions+acis@alphaeducation.edu.in',
  'admissions+apm@alphaeducation.edu.in',
  'admissions+awv@alphaeducation.edu.in',
  'admissions.andheri@sws.edu.in',
  'admissions.aurangabad@universal.edu.in',
  'admissions.bandra@sws.edu.in',
  'admissions.chembur@universal.edu.in',
  'admissions.dahisar@universal.edu.in',
  'admissions.eisb@eis.edu.in',
  'admissions.ghatkopar@universal.edu.in',
  'admissions.goregaon@sws.edu.in',
  'admissions.malad@universal.edu.in',
  'admissions.miraroad@universal.edu.in',
  'admissions.nashik@eis.edu.in',
  'admissions.nashik@universal.edu.in',
  'admissions.stjohns@universal.edu.in',
  'admissions.tardeo@universal.edu.in',
  'admissions.thane@universal.edu.in',
  'erp.support+sws-goregaon@universal.edu.in',
  'amir.shaikh+ihs@universal.edu.in',
  'barkha.dhepe+ihs@universal.edu.in',
  'gaurav+ab@joinether.in',
  'gaurav+acis@joinether.in',
  'gaurav+apm@joinether.in',
  'gaurav+awv@joinether.in',
  'gaurav+eisb@joinether.in',
  'gaurav+eisn@joinether.in',
  'gaurav+ihs@joinether.in',
  'gaurav+local@joinether.in',
  'gaurav+ppsb@joinether.in',
  'gaurav+sju@joinether.in',
  'gaurav+sous@joinether.in',
  'gaurav+sws-a@joinether.in',
  'gaurav+sws-b@joinether.in',
  'gaurav+sws-g@joinether.in',
  'gaurav+uahm@joinether.in',
  'gaurav+uhd@joinether.in',
  'gaurav+uhm@joinether.in',
  'gaurav+uhsa@joinether.in',
  'gaurav+uhsc@joinether.in',
  'gaurav+uht@joinether.in',
  'gaurav+usg@joinether.in',
  'gaurav+ust@joinether.in',
  'sankar+ab@joinether.in',
  'sankar+acis@joinether.in',
  'sankar+apm@joinether.in',
  'sankar+awv@joinether.in',
  'sankar+eisb@joinether.in',
  'sankar+eisn@joinether.in',
  'sankar+ihs@joinether.in',
  'sankar+local@joinether.in',
  'sankar+ppsb@joinether.in',
  'sankar+sju@joinether.in',
  'sankar+sous@joinether.in',
  'sankar+sws-a@joinether.in',
  'sankar+sws-b@joinether.in',
  'sankar+sws-g@joinether.in',
  'sankar+uahm@joinether.in',
  'sankar+uhd@joinether.in',
  'sankar+uhm@joinether.in',
  'sankar+uhsa@joinether.in',
  'sankar+uhsc@joinether.in',
  'sankar+uht@joinether.in',
  'sankar+usg@joinether.in',
  'sankar+ust@joinether.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'jay.sharma+admin@joinether.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'manjusha.bpis@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com'
];

export const usersWithFinalPromotionAccess = [
  'bhoomi+admin@joinether.in',
  'stellar@universal.edu.in',
  'erp.support+ab@universal.edu.in',
  'erp.support+acis@universal.edu.in',
  'erp.support+apm@universal.edu.in',
  'erp.support+awv@universal.edu.in',
  'erp.support+eisb@universal.edu.in',
  'erp.support+eisn@universal.edu.in',
  'erp.support+ppsb@universal.edu.in',
  'erp.support+sju@universal.edu.in',
  'erp.support+sous@universal.edu.in',
  'erp.support+sws-andheri@universal.edu.in',
  'erp.support+sws-bandra@universal.edu.in',
  'erp.support+sws-goregaon@universal.edu.in',
  'erp.support+uahm+teacher@universal.edu.in',
  'erp.support+uahm@universal.edu.in',
  'erp.support+uhd@universal.edu.in',
  'erp.support+uhm@universal.edu.in',
  'erp.support+uhsa@universal.edu.in',
  'erp.support+uhsc@universal.edu.in',
  'erp.support+uht@universal.edu.in',
  'erp.support+usg@universal.edu.in',
  'erp.support+ust+teacher@universal.edu.in',
  'erp.support+ust@universal.edu.in',
  'erp.support+ihs@universal.edu.in',
  'varsha+ab@joinether.in',
  'varsha+acis@joinether.in',
  'varsha+apm@joinether.in',
  'varsha+awv@joinether.in',
  'varsha+eisb@joinether.in',
  'varsha+eisn@joinether.in',
  'varsha+ihs@joinether.in',
  'varsha+local@joinether.in',
  'varsha+ppsb@joinether.in',
  'varsha+sju@joinether.in',
  'varsha+sous@joinether.in',
  'varsha+sws-a@joinether.in',
  'varsha+sws-b@joinether.in',
  'varsha+sws-g@joinether.in',
  'varsha+uahm@joinether.in',
  'varsha+uhd@joinether.in',
  'varsha+uhm@joinether.in',
  'varsha+uhsa@joinether.in',
  'varsha+uhsc@joinether.in',
  'varsha+uht@joinether.in',
  'varsha+usg@joinether.in',
  'varsha+ust@joinether.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'manjusha.bpis@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com',
  'ayushi.bpis@gmail.com'
];

export const usersWithDeleteExamsAccess = [
  'stellar@universal.edu.in',
  'nauka+localschooladmin@joinether.in',
  'riddhi.primary+admin@aspeenutanacademy.org',
  'erp.support+ab@universal.edu.in',
  'erp.support+acis@universal.edu.in',
  'erp.support+apm@universal.edu.in',
  'erp.support+awv@universal.edu.in',
  'erp.support+eisb@universal.edu.in',
  'erp.support+eisn@universal.edu.in',
  'erp.support+ppsb@universal.edu.in',
  'erp.support+sju@universal.edu.in',
  'erp.support+sous@universal.edu.in',
  'erp.support+sws-andheri@universal.edu.in',
  'erp.support+sws-bandra@universal.edu.in',
  'erp.support+sws-goregaon@universal.edu.in',
  'erp.support+uahm+teacher@universal.edu.in',
  'erp.support+uahm@universal.edu.in',
  'erp.support+uhd@universal.edu.in',
  'erp.support+uhm@universal.edu.in',
  'erp.support+uhsa@universal.edu.in',
  'erp.support+uhsc@universal.edu.in',
  'erp.support+uht@universal.edu.in',
  'erp.support+usg@universal.edu.in',
  'erp.support+ust+teacher@universal.edu.in',
  'erp.support+ust@universal.edu.in',
  'erp.support+ihs@universal.edu.in',
  'sunil.bawane@primusschool.edu.in',
  'alauddin.shaikh@universal.edu.in',
  'milind.kadam@universal.edu.in',
  'darshan.khapare@universal.edu.in',
  'kiran.bhalekar@universal.edu.in',
  'mandar.wanarkar@universal.edu.in',
  'ajinkya.divekar@universal.edu.in',
  'gomase.manoj@universal.edu.in',
  'ajay.kshirsagar@universal.edu.in',
  'suraj.dhuri@universal.edu.in',
  'shashank.gujar@universal.edu.in',
  'manager.it@eis.edu.in',
  'sagar.sonawane@eis.edu.in',
  'manager.it+ab@alphaeducation.edu.in',
  'rizwaan.su@alphaeducation.edu.in',
  'manager.it+apm@alphaeducation.edu.in',
  'manager.it+awv@alphaeducation.edu.in',
  'vinoda.v@ihs.edu.in',
  'darshak.patel@sws.edu.in',
  'rohan.pardale@sws.edu.in',
  'jayesh.tiwari@sws.edu.in',
  'bhoomi+admin@joinether.in',
  'ekta+admin@joinether.in',
  'varsha.jayashankar+uht@universal.edu.in',
  'varsha+bpis@joinether.in',
  'gaurav+bpis@joinether.in',
  'santosh+bpis@joinether.in',
  'dipika.b+local@joinether.in',
  'jay.sharma+demo4-admin@joinether.in',
  'bhoomi+demo4-admin@joinether.in',
  'satish.wv@gmail.com',
  'abhilashhp.1991+admin@gmail.com',
  'manjusha.bpis@gmail.com',
  'nupoor2905@gmail.com',
  'principal@bpismumbai.com',
  'vidyak.bpis@gmail.com',
  'tiwari.rashmibpis@gmail.com',
  'rachana.bpis.2023@gmail.com'
];
